<template>
    <a class="uk-margin-top uk-align-right uk-icon-link" @click.prevent="back"><span uk-icon="icon: arrow-left"></span> Volver atrás</a>
</template>

<script>
export default {
  name: 'goBack',
  methods: {
    back () {
      this.$emit('goBack')
    }
  }
}
</script>
